// Ảnh CDN có 2 đường: /images/<file> = ảnh GỐC (giữ nguyên chất lượng, dùng khi xem
// chi tiết / tải xuống) và /thumb/<file> = bản 320px nginx sinh tại chỗ (~20-60KB,
// dùng cho mọi lưới ảnh nhỏ). Đo 31/08/2026: 24 thumb trang thành tích tháng 18,5MB → 1,0MB.
const CDN_IMAGES_PREFIX = 'https://cdn.cungvedich.vn/images/';

// URL ngoài CDN (thumb Facebook cũ...) trả về nguyên vẹn — không có bản thumb.
export const cdnThumb = (url) =>
  typeof url === 'string' && url.startsWith(CDN_IMAGES_PREFIX)
    ? url.replace('/images/', '/thumb/')
    : url;

// Thumb lỗi (định dạng lạ, file mất) → thử lại ảnh gốc 1 lần trước khi bỏ cuộc.
// Trả về true nếu đã đổi src sang gốc (caller đừng vẽ placeholder vội).
export const retryOriginalOnce = (imgEl) => {
  if (imgEl.dataset.retriedOriginal) return false;
  const original = imgEl.src.replace('/thumb/', '/images/');
  if (original === imgEl.src) return false;
  imgEl.dataset.retriedOriginal = '1';
  imgEl.src = original;
  return true;
};

// Tải ảnh gốc về máy (CDN mở CORS * nên fetch được; thẻ <a download> trần không
// ép tải cross-origin vì server trả Content-Disposition: inline).
export const downloadImage = async (url, filename) => {
  const res = await fetch(url);
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  const blob = await res.blob();
  const href = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = href;
  a.download = filename || url.split('/').pop() || 'anh.jpg';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(href);
};
